import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/hint/show-hint.js';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/hint/javascript-hint.js';
export default {
  name: 'CodemirrorWrapper',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => ({})
    },
    lazy: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isVisible: false,
      cmInstance: null
    };
  },
  computed: {
    defaultCmOptions() {
      return {
        viewportMargin: 10,
        workDelay: 300,
        workTime: 35,
        gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        foldGutter: true,
        lineWrapping: false
      };
    }
  },
  watch: {
    value(newVal) {
      if (this.cmInstance && this.cmInstance.getValue() !== newVal) {
        this.cmInstance.setValue(newVal);
      }
    },
    isVisible(newVal) {
      if (newVal && !this.cmInstance) {
        this.$nextTick(() => {
          this.initializeCodeMirror();
        });
      }
    }
  },
  mounted() {
    if (this.lazy) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.$nextTick(() => {
              this.initializeCodeMirror();
            });
            observer.disconnect();
          }
        });
      });
      observer.observe(this.$refs.wrapper);
    } else {
      this.isVisible = true;
      this.$nextTick(() => {
        this.initializeCodeMirror();
      });
    }
  },
  beforeDestroy() {
    this.cleanupCodeMirror();
  },
  methods: {
    initializeCodeMirror() {
      if (this.cmInstance) {
        return;
      }
      this.cmInstance = new CodeMirror(this.$refs.editor, {
        value: this.value,
        ...this.options,
        ...this.defaultCmOptions
      });
      this.overrideEventHandlers();
      this.cmInstance.on('change', () => {
        this.$emit('input', this.cmInstance.getValue());
      });
      this.cmInstance.on('focus', () => {
        this.$emit('focus');
      });
      this.cmInstance.on('blur', () => {
        this.$emit('blur');
      });
      this.$emit('codemirror-ready');
    },
    overrideEventHandlers() {
      if (!this.cmInstance) {
        return;
      }
      // Get the DOM element
      const element = this.cmInstance.getWrapperElement();
      // remove existing event listeners
      element.removeEventListener('touchstart', this.cmInstance._handlers.touchstart);
      element.removeEventListener('touchmove', this.cmInstance._handlers.touchmove);
      element.removeEventListener('mousewheel', this.cmInstance._handlers.mousewheel);
      // add new event listeners with passive option
      element.addEventListener('touchstart', this.cmInstance._handlers.touchstart, {
        passive: true
      });
      element.addEventListener('touchmove', this.cmInstance._handlers.touchmove, {
        passive: true
      });
      element.addEventListener('mousewheel', this.cmInstance._handlers.mousewheel, {
        passive: true
      });
    },
    cleanupCodeMirror() {
      if (this.cmInstance) {
        // remove event listeners
        const element = this.cmInstance.getWrapperElement();
        if (element) {
          element.removeEventListener('touchstart', this.cmInstance._handlers.touchstart);
          element.removeEventListener('touchmove', this.cmInstance._handlers.touchmove);
          element.removeEventListener('mousewheel', this.cmInstance._handlers.mousewheel);
        }
        // clear the instance
        this.cmInstance = null;
      }
    },
    onTextareaInput(e) {
      this.$emit('input', e.target.value);
    }
  }
};